import { supabase } from './supabase';
import { RealtimeChannel } from '@supabase/supabase-js';

/**
 * Subscribe to order changes
 */
export function subscribeToOrders(
  venueId: string,
  callback: (payload: any) => void
): RealtimeChannel {
  return supabase
    .channel(`orders:${venueId}`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'orders',
        filter: `venue_id=eq.${venueId}`,
      },
      callback
    )
    .subscribe();
}

/**
 * Subscribe to tab changes
 */
export function subscribeToTabs(
  venueId: string,
  callback: (payload: any) => void
): RealtimeChannel {
  return supabase
    .channel(`tabs:${venueId}`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'tabs',
        filter: `venue_id=eq.${venueId}`,
      },
      callback
    )
    .subscribe();
}

/**
 * Subscribe to order status changes
 */
export function subscribeToOrderStatus(
  orderId: number,
  callback: (payload: any) => void
): RealtimeChannel {
  return supabase
    .channel(`order:${orderId}`)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'orders',
        filter: `id=eq.${orderId}`,
      },
      callback
    )
    .subscribe();
}

/**
 * Subscribe to tab status changes
 */
export function subscribeToTabStatus(
  tabId: number,
  callback: (payload: any) => void
): RealtimeChannel {
  return supabase
    .channel(`tab:${tabId}`)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'tabs',
        filter: `id=eq.${tabId}`,
      },
      callback
    )
    .subscribe();
}

/**
 * Subscribe to tab + its orders while the tab drawer is open.
 */
export function subscribeToTabDrawer(
  tabId: number,
  callback: (payload: any) => void
): RealtimeChannel {
  return supabase
    .channel(`tab-drawer:${tabId}`)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'tabs',
        filter: `id=eq.${tabId}`,
      },
      callback
    )
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'orders',
        filter: `tab_id=eq.${tabId}`,
      },
      callback
    )
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'tabs_splits',
        filter: `tab_id=eq.${tabId}`,
      },
      callback
    )
    .subscribe();
}

/**
 * Unsubscribe from channel
 */
export function unsubscribeChannel(channel: RealtimeChannel) {
  supabase.removeChannel(channel);
}

